"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLog = getLog;
function getAppLogProvider() {
    if (typeof window === 'undefined') {
        // eslint-disable-next-line @typescript-eslint/no-var-requires,global-require
        const Provider = require('./log/serverLog').default;
        return new Provider();
    }
    else {
        // eslint-disable-next-line @typescript-eslint/no-var-requires,global-require
        const Provider = require('./log/clientLog').default;
        return new Provider();
    }
}
const appLogProvider = getAppLogProvider();
function getLog(module, options) {
    return appLogProvider.getAppLog(module, options);
}
//# sourceMappingURL=log.js.map